import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '@/views/Index';
const List = resolve => require(['@/views/List'], resolve);
const Detail = resolve => require(['@/views/Detail'], resolve);
const Home = resolve => require(['@/views/Home'], resolve);
const Search = resolve => require(['@/views/Search'], resolve);
const About = resolve => require(['@/views/About'], resolve);
const MOrderDetail = resolve => require(['@/Mobile/OrderDetail'], resolve);


Vue.use(VueRouter);

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/search', // 搜索
      name: 'Search',
      component: Search
    },
    {
      path: '/list/:classifyId', // 列表
      name: 'List',
      component: List
    },
    {
      path: '/detail/:id', // 详情
      name: 'Detail',
      component: Detail
    },
    {
      path: '/about/:type',
      name: 'About',
      component: About
    },
    {
      path: '/home', // 个人中心
      name: 'Home',
      component: Home
    },
    {
      path: '/m/orderDetail', // 个人中心
      name: 'mOrderDetail',
      component: MOrderDetail,
      meta: {
        noLayout: true
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js